import React from 'react';
import getDisplayName from 'components/utils/getDisplayName';
import completeTrailmixCustomStep from 'lib/completeTrailmixCustomStep';

const withContentEventHandlerProps = (WrappedComponent) => {
  class WithContentEventHandlerProps extends React.Component {
    eventHandlers() {
      const { content: { type }, eventHandlers } = this.props;
      const handlers = {...eventHandlers};
      if (type === 'customstep') {
        const { completionData: { userSlug, trailmixSlug, customStepId } } = this.props;
        handlers.completeCustomStepHandler =
          completeTrailmixCustomStep(userSlug, trailmixSlug, customStepId);
      }
      return { eventHandlers: handlers };
    }

    render() {
      const { actionContext, ...passThroughProps } = this.props;

      return (
        <WrappedComponent
          {...passThroughProps}
          {...this.eventHandlers()}
        />
      );
    }
  }

  WithContentEventHandlerProps.displayName = `WithContentEventHandlerProps(${getDisplayName(
    WrappedComponent
  )})`;

  return WithContentEventHandlerProps;
};

export default withContentEventHandlerProps;
